///////////////////////////////////////////////////////////////////////////////////////////////
///////////// UMC CUSTOMER FEEDBACK CODE (FIlter by OPP TYPE AND TITLE) ///////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import Modal from 'react-modal'
import ModalContent from "../../common/Modal/ModalContent";
import close_modal from '../../assets/ic_close_wh.svg'
import { Button } from "../../common/Button/Button";
import ReactTable from "react-table";
import "react-table/react-table.css";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import Select from "react-select";
import find from "lodash/find";
import { Info } from "react-feather";
import { ControlledInput } from "../../common/Input/Input";
import ESPNotesLogDropdown from "../../containers/EServicePartnerServiceRequests/ESPNotesLogDropdown";
import ReactDatePicker from "react-datepicker";
import { getESPUser } from "../../utils/localStorage";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import SelectServiceStatusDropdown from "./SelectServiceStatusDropdown";
import CentralizedNotesModal from "../ServiceRequests/Handholder/CentralizedNotesModal";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../common/Pagination/Pagination";
import copysvg from "./../../assets/arrow_copy.svg";
import ic_filter from "./../../assets/ic_filter.svg";
import { toast } from "react-toastify";
import colors from "./../../styles/_colors.scss";
import ESPNotesTrailModal from "./ESPNotesTrailModal";
import ESPSMSTrailModal from "./ESPSMSTrailModal";
import SPLedFilterModel from "./SPLedFilterModel";
import CentralizedSMSLogModal from "../ServiceRequests/Handholder/CentralizedSMSLogModel";
import ESPSMSTrail from "../../containers/EServicePartnerServiceRequests/ESPSMSTrail";
import ESPViewAllNotesModal from "./ESPViewAllNotesModal";
import DePreneurListingModal from "./DePreneurListingModal";
import Checkbox from "../../common/Checkbox/Checkbox";
import { X } from "react-feather";
import api from "../../utils/api";
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import rightIcon from '../../assets/right.png'
import wrongIcon from '../../assets/wrong.png'
import { DOWNLOAD_UMC_CUSTOMER_FEEDBACK} from "../../utils/constants";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function ESPCustomerFeedbackGrid(props) {
	// Below All related to customer feedback screen
	const [feedbackList, setFeedbackList] = useState([]);
	const [displayRecordCount, setDisplayRecordCount] = useState(null)
	const [umcCustomerFeedbackDetail, setUmcCustomerFeedbackDetail] = useState(null);
	const [expandedRows, setExpandedRows] = useState({});
	const [selectedFeedback, setSelectedFeedback] = useState(null);
	const [selectedFeedbackLoading, setSelectedFeedbackLoading] = useState(false);
	const [customerFeedbackListLoading, setCustomerFeedbackListLoading] = useState(false);
	const [pageSize, setPageSize] = useState(5); // responsible for select option in page size
	 const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
			value: "5",
			label: "5",
		});
	const [currentPage, setcurrentPage] = useState(0);
	const [pages, setPages] = useState(0)

	const columns = [
		{
			id: "opportunity_date",
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			Header: "Opportunity Date",
			accessor: "opportunity_date",
			style: { 'whiteSpace': 'unset' },
			width: 120,
			Cell: ({ original }) =>
				original?.opportunity_date ? (moment(original.dtRequested).format("DD/MM/YYYY")) : ("NA"),
		},
		{
			id: "umc_entry_id",
			headerStyle:  { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			Header: "Entry Id.",
			accessor: "umc_entry_id",
			style: { 'whiteSpace': 'unset' },
			width: 120,
			style: { 'whiteSpace': 'unset' },
			Cell: ({original}) => (
				<span >{original?.umc_entry_id}</span>
			)

		},
		{
			id: "customer_name",
			headerStyle:  { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			Header: "Customer Name",
			accessor: "customer_name",
			// width: 120,
			style: { 'whiteSpace': 'unset' },
			Cell: ({original}) => (
				<span >{original?.customer_name}</span>
			)
		},
		{
			id: "opportunity_type",
			headerStyle:  { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			Header: "Opp. Type",
			accessor: "opportunity_type",
			style: { 'whiteSpace': 'unset' },
			Cell: ({original}) => (
				<span >{original?.opportunity_type}</span>
			)
		},
		{
			id: "opportunity_title",
			headerStyle:  { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			Header: "Opp. Title",
			accessor: "umc_entry_id",
			style: { 'whiteSpace': 'unset' },
			Cell: ({original}) => (
				<span >{original?.opportunity_title}</span>
			)
		},
		{
			id: "mobile",
			headerStyle:  { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			Header: "Mobile",
			accessor: "umc_entry_id",
			style: { 'whiteSpace': 'unset' },
			Cell: ({original}) => (
				<span >{original?.mobile}</span>
			)
		}
	];

	useEffect(()=>{
		console.log(selectedPageSizeOption, ">>>perpage changes useEffect ran");
		
		getAllUmcFeedbackList();

		// setCustomerFeedbackListLoading(false)
	}, [selectedPageSizeOption, currentPage])

	const getAllUmcFeedbackList = () =>{
		setCustomerFeedbackListLoading(true)
		
		const selectedType = selectedOppType?.label;

		let titles = [];
		selectedOppTitle?.forEach(title => title.id? titles.push(title.id) : "")
		// let selectedTitles = Object.keys(titles)

		const filterOptions = {
			type: selectedType,
			title: titles
		}

		api.getUmcFeedbackList(selectedPageSizeOption?.value, currentPage+1, filterOptions)
		.then(res => {
			console.log(res, ">>>customer feedback response");
			setFeedbackList(res?.data?.Data?.feedback_list)
			setDisplayRecordCount({displayCount: Boolean(res?.data?.Data?.total_feedback), count: res?.data?.Data?.total_feedback});
			
			const totalFeedbacks = res?.data?.Data?.total_feedback
			const totalPages = Math.ceil(totalFeedbacks / selectedPageSizeOption?.value)
			console.log(totalPages, ">>>>>total pages");

			if(totalPages){
				setPages(totalPages) // responsible for showing page numbers in pagination
			}else {
				setPages(0)
			}
			setCustomerFeedbackListLoading(false)
		}).catch(err =>{
			console.log("error getting umc customers feedback: ", err);
			setCustomerFeedbackListLoading(false)
		})

	}

	// this effect is used when search is clicked
	const [searchButtonClicked, setSearchClicked] = useState(false);

	useEffect(()=>{
		getAllUmcFeedbackList()
	}, [searchButtonClicked]);


	// below effect used for getting feedback detail
	useEffect(()=>{
		getUmcFeedbackDetailApiCall()
	}, [selectedFeedback])

	const getUmcFeedbackDetailApiCall = () =>{
		console.log(selectedFeedback, ">>>>selected Feedback before api call");
		setSelectedFeedbackLoading(true)

		api.getUmcFeedbackDetail(selectedFeedback)
		.then(res => {
			console.log(res, ">>>>getUmcFeedbackDetail ");
			setUmcCustomerFeedbackDetail(res?.data?.Data);
			setSelectedFeedbackLoading(false)
		})
		.catch(err  => {
			console.log("Error getting umc customer feedback detail ", err);
			setSelectedFeedbackLoading(false)
		})
	}

	const handlePageChange = (val) =>{
		console.log(val, ">>>>> handlePageCLicked");
		// have to change the current page value
	}

	const dateFormatter = (str) => {
		return str?.split("-")?.reverse()?.join("-")
	}

	// below states and functions for filters
	const [oppTypeNameList, setOppTypeNameList] = useState()
	const [selectedOppType, setSelectedOppType] = useState(null)
	const [oppTitleNameList, setOppTitleNameList] = useState([])
	const [selectedOppTitle, setSelectedOppTitle] = useState([])
	const [downloadCustomerFeedbackTitleIds, setDownloadCustomerFeedbackTitleIds] = useState(null);
	useEffect(() => {
        const { tempOppTypeServiceNames } = api.oppTypeListApi()
        .then(({data}) => {
            const formattedData = data.results.map((ele) => ({
                value: ele.sServiceCode,
                label: ele.sServiceName
            }))
            setOppTypeNameList(formattedData)
        })
    }, [])

	const onOppTypeChange = (option) => {
        setSelectedOppType(option)
		setSelectedOppTitle([])
        getOppTitleNames(option)
    }

	const getOppTitleNames = (ele) => {
        if(ele) {
            const { tempOppTitleNames } = api.getOppTitles(ele.label)
			.then((data) => {
				console.log(data,">>>Data");
				
				const formattedData = data?.data?.Data["opportunity_list"].map((ele) => ({
					value: ele.opportunity_title,
					label: ele.opportunity_title,
					id: ele.opportunity_id
				}))

				console.log(formattedData, ">>>>formattedData");
				
				setOppTitleNameList(formattedData)
			})
        } else {
            setOppTitleNameList([])
            setSelectedOppTitle([]) 
			setDownloadCustomerFeedbackTitleIds(null);
        }
       
    }

	const toggleAllOppTitle = () => {
        if (selectedOppTitle.length != oppTitleNameList.length && selectedOppTitle.length != (oppTitleNameList.length + 1)) {
            let temp = []
      
            if (selectedOppTitle.includes({ label: "All", value: "*" })) {
              temp = selectedOppTitle
            } else {
              temp = [{ label: "All", value: '*' }]
            }
      
            let tempSR = oppTitleNameList.map((e) => {
              if (!temp.includes(e)) {
                temp = temp.concat(e)
              }
              return e
            })
            setOppTitleNameList(tempSR)
            setSelectedOppTitle(temp)
			let allIds = filterTitleIds(temp);
			setDownloadCustomerFeedbackTitleIds(allIds);
          //   getTagsDropdown(processFilters(temp))
          } else {
            setSelectedOppTitle([])
          //   getTagsDropdown(null)
		  	setDownloadCustomerFeedbackTitleIds(null);
          }
    }

	const onOppTitleChange = (options) => {
        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedOppTitle([{ value: "*", label: "All" }]);
            // getTagsDropdown(processFilters(options))
			let allIds = filterTitleIds([{ value: "*", label: "All" }]);
			setDownloadCustomerFeedbackTitleIds(allIds);
        } else {
			let allIds = filterTitleIds(options.filter((opt) => opt.value !== "*"));
            setSelectedOppTitle(options.filter((opt) => opt.value !== "*"));
            // getTagsDropdown(processFilters(options))
			setDownloadCustomerFeedbackTitleIds(allIds);
        }
    }

	const filterTitleIds = (data) => {
		console.log(data, ">>>>data in filterTitleIds");
		let allSelectedTitleIds = [];

		data.forEach(title => {
			if(title.id){
				allSelectedTitleIds.push(title.id)
			}
		})

		return allSelectedTitleIds.join(",");
	}



	const handleSearchClick = async () => {
		// Below API call to fetch data according to filter items
		console.log("Search clicked function ran");
		setSearchClicked(!searchButtonClicked)
    };



	// console.log(feedbackList, ">>>feedbacklist");
	console.log(umcCustomerFeedbackDetail, ">>>> umcCustomerFeedbackDetail");
	// console.log(expandedRows, ">>>>expandedRows");
	// console.log(selectedFeedback, ">>>>selectedFeedback");
	// console.log(displayRecordCount, ">>>>displayRecordCount");
	// console.log(selectedPageSizeOption, ">>>selectedPageSizeOption");
	
	console.log(selectedOppType, ">>>SelectedOppType");
	console.log(selectedOppTitle, ">>>selectedOppTitle");
	console.log(`${DOWNLOAD_UMC_CUSTOMER_FEEDBACK}&opp_type=${selectedOppType?.label ? selectedOppType?.label : ""}&opp_title=${downloadCustomerFeedbackTitleIds?downloadCustomerFeedbackTitleIds:""}`, ">>>>download feedback url");
	
	
	return (
		<div className={`row row-container ${customerFeedbackListLoading && "set-opacity"}`} >
			{customerFeedbackListLoading && <Spinner className="center-screen" />}


			<div style={{ clear: "both" }}></div>
			<div className="col-12 mb-3">
				<div className="row">
					<div className="col-2 conv-zindex">
							<div>
								<Select
									options={oppTypeNameList}
									onChange={onOppTypeChange}
									value={selectedOppType}
									placeholder="Select Opp Type"
									isClearable
								/>
							</div>
					</div>

					<div className="col-2 conv-zindex">
							<div className="">
								<MultiSelectAll
									toggleAll={toggleAllOppTitle}
									toggleSelection={onOppTitleChange}
									checkboxItemsList={oppTitleNameList}
									selectedOptions={selectedOppTitle}
									placeholderButtonLabel="Select Opp Title"
								/>
							</div>
					</div>

					<div className="col-2 conv-zindex">
						<a href={`${DOWNLOAD_UMC_CUSTOMER_FEEDBACK}&opp_type=${selectedOppType?.label ? selectedOppType?.label : ""}&opp_title=${downloadCustomerFeedbackTitleIds?downloadCustomerFeedbackTitleIds:""}`} target="_blank">
							<button className="my-services-model-submit-btn"
							>Download Feedback</button>
						</a>
					</div>


					<div className="col-6">
						<button
							className="con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
							onClick={handleSearchClick}>
							Search
						</button>
						{/* <input
							type="text"
							className="conv-float-right form-control search-input"
							placeholder="Search"
							onChange={props.onSearchInputChange}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									props.onSearchClicked();
								}
							}}
							autoComplete={false}
							value={props.searchTerm}
							name="searchTerm"
						/> */}
					</div>
				</div>
			</div>

			<div className={`col-12 service-partner spled-container ${props.FollowUpCount > 0 || props.AllFollowUpCount > 0 ? ' conv-mt5' : ' conv-mt10'}`}>
				{<ReactTableFixedColumns
					minRows={0}
					data={feedbackList || []}
					columns={columns}
					manual
					// defaultPage={currentPage}
					pages={pages}
					page={currentPage} // purple colors the selected page
					isTotalRecords = {true}
					pageSize={pageSize}
					defaultPageSize={3}
					showPagination={true}
					pageSizeOptions={[5, 10, 20]}
					onFetchData={(state, instance) => {
						console.log(state.page, ">>>statet On onFetchData ran....");
						console.log(instance, ">>>>instance on onFetchData ran");
						setcurrentPage(state?.page ? state?.page : 0) // when page changes an api is called with the current pagge + 1
					}}
					onPageSizeChange={(option) => {
						setSelectedPageSizeOption(option);
						setPageSize(option?.value)
					}}

					// mycode
					expanded={expandedRows}
					onExpandedChange={(newExpanded, index, event, row) => {
						if (newExpanded[index[0]] === false) {
							newExpanded = {}
						} else {
							Object.keys(newExpanded).map(k => {
								newExpanded[k] = parseInt(k) === index[0] ? {} : false
							})
						}
						setExpandedRows(newExpanded)
					}}

					SubComponent={(row) => {
						setSelectedFeedback(row.original.feedback_id);
						console.log(row, ">>>>>row");
						console.log(umcCustomerFeedbackDetail, ">>>>>umcCustomerFeedbackDetail inside");
						
						return (
							<div
								className="row conv-pt20 conv-pl15 conv-bg-f8f8f8 conv-mr0"
								style={{backgroundColor:""}}
							>
								<div style={{ backgroundColor: "", position: "relative", minHeight: "100px", width:"100%" }}>
									{selectedFeedbackLoading && (
										<div
											style={{
												position: "absolute",
												top: "50%",
												left: "50%",
												transform: "translate(-50%, -50%)",
												zIndex: 1,
											}}
										>
											<Spinner className="top" />
										</div>
									)}

									{/* Add a blur effect or content below spinner */}
									<div className="" style={{ backgroundColor:"red", opacity: selectedFeedbackLoading ? 0.5 : 1 }}>
										{/* Custimer Info Row */}
										<div className="row conv-pl15 conv-bg-f8f8f8 conv-mr0 umc-customer-feedback-main-container" style={{backgroundColor:""}}>
											<div className="col-12 conv-pl15 conv-pb20 conv-bg-f8f8f8 conv-mr0">
												<div className="row" style={{backgroundColor:""}}>
													<div className="col-4" style={{backgroundColor:""}}>
														<div className="row">
															<div className="col-12 lg-colored-label conv-pb10">
																Customer Information
															</div>
															<div className="col-6 lg-black-text">
																<span>
																	{row?.original?.customer_name}
																</span>	
															</div>
															<div className="col-5 lg-black-text">
																{row?.original?.mobile}
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="col-12 conv-pl15 conv-pb20  conv-bg-f8f8f8 conv-mr0">
												<div className="row" style={{backgroundColor:""}}>
													<div className="col-4 conv-mr15 conv-ml15" style={{backgroundColor:"", border:"1px solid purple", borderRadius:"10px", padding:"10px"}}>
														<div className="row">
															<div className="col-12 lg-colored-label conv-pb10">
																Opportunity Information
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-6">
																		<span>Opp. Type: </span>
																	</div>

																	<div className="col-6">
																		<span>{row?.original?.opportunity_type}</span>
																	</div>
																</div>
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-6">
																		<span>Opp. Title: </span>
																	</div>
																	<div className="col-6">
																		<span>{row?.original?.opportunity_title}</span>
																	</div>
																</div>
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-6">
																		<span>Opp. Date: </span>
																	</div>
																	<div className="col-6">
																		<span>{dateFormatter(umcCustomerFeedbackDetail?.opportunity_date)}</span>
																	</div>
																</div>
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-6">
																		<span>Opp. Location: </span>
																	</div>
																	<div className="col-6">
																		<span>{umcCustomerFeedbackDetail?.opportunity_location}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>

													<div className="col-4 conv-mr15" style={{backgroundColor:"", border:"1px solid purple", borderRadius:"10px", padding:"10px"}}>
														<div className="row">
															<div className="col-12 lg-colored-label conv-pb10">
																Sales Information
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-6">
																		<span>Footfall Received: </span>
																	</div>

																	<div className="col-6">
																		<span>{umcCustomerFeedbackDetail?.opportunity_footfall_received}</span>
																	</div>
																</div>
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-6">
																		<span>Total Sale: </span>
																	</div>
																	<div className="col-6">
																		<span>{umcCustomerFeedbackDetail?.opportunity_total_sale}</span>
																	</div>
																</div>
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-6">
																		<span>Products Sold: </span>
																	</div>
																	<div className="col-6">
																		<span>{umcCustomerFeedbackDetail?.opportunity_products_sold}</span>
																	</div>
																</div>
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-6">
																		<span>Sales Per Month:</span>
																	</div>
																	<div className="col-6">
																		<span>{umcCustomerFeedbackDetail?.opportunity_sale_per_month}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>

													<div className="col-3" style={{backgroundColor:"", border:"1px solid purple", borderRadius:"10px", padding:"10px"}}>
														<div className="row">
															<div className="col-12 lg-colored-label conv-pb10">
																Customer Feedback
															</div>
															<div className="col-12 lg-black-text conv-pb5">
																<div className="row">
																	<div className="col-12">
																		<textarea
																			disabled={true}
																			style={{
																				border: "none",
																				outline: "none",
																				resize: "none",
																				width: "100%",
																				height: "100px",
																				background: "transparent",
																			}}
																			cols={35} 
																			rows={6}
																			value={umcCustomerFeedbackDetail?.opportunity_experience_feedback || ""}
																		/>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						);
					}}
					
					PaginationComponent={(paginationProps) => (
                        <Pagination
                            {...paginationProps}
                            displayRecordCount={displayRecordCount}
                    />
                    )}
					style={{ overflowY: "initial", height: "500px" }}
					handlePageChange={handlePageChange}
					className="-striped"
				/>}
			</div>
		</div>

	);
}